import eventsWithThumbnails from './eventsWithThumbnails';
import getEventAssetIds from '../../../components/Notifications/helpers/getEventAssetIds';

/**
 * Set notification asset thumnail loading
 * @param {Object[]} items
 * @param {string[]} ids
 * @param {string} keyName
 * @param {*} value
 * @returns {Object[]} items
 */
const setThumbnailsField = (items, ids, keyName, value) => items.map((item) => {
  if (!item.data || !eventsWithThumbnails.includes(item.type)) {
    return item;
  }
  const assetIds = getEventAssetIds(item, 4);
  if (!assetIds.some((id) => ids.includes(id))) {
    return item;
  }
  return {
    ...item,
    thumbnail: { ...item.thumbnail, [keyName]: value },
    thumbnails: (item.thumbnails || []).map((thumb) => (
      ids.includes(thumb._id) ? { ...thumb, [keyName]: value } : thumb
    )),
  };
});

export default setThumbnailsField;
